document.addEventListener("DOMContentLoaded", function () {
  const menuToggle = document.getElementById("custom-menu-toggle");
  const menuClose = document.getElementById("custom-menu-close");
  const mobileNav = document.getElementById("custom-mobile-nav");
  const overlay = document.getElementById("custom-overlay");
  const openMenu = () => {
    mobileNav.classList.add("custom-open");
    overlay.classList.add("custom-show");
    document.body.classList.add("no-scroll");
  };
  const closeMenu = () => {
    mobileNav.classList.remove("custom-open");
    overlay.classList.remove("custom-show");
    document.body.classList.remove("no-scroll");
  };
  menuToggle.addEventListener("click", openMenu);
  menuClose.addEventListener("click", closeMenu);
  overlay.addEventListener("click", closeMenu);
  const submenuParents = document.querySelectorAll(
    ".custom-nav-mobile .parant-menu > a"
  );

  // submenuParents.forEach((parent) => {
  //   parent.addEventListener("click", (event) => {
  //     event.preventDefault();
  //     const submenu = parent.nextElementSibling;
  //     const arrow = parent.querySelector(".custom-arrow");
  //     if (submenu) {
  //       if (submenu.style.display === "block") {
  //         submenu.style.display = "none";
  //         arrow.classList.remove("down");
  //         arrow.classList.add("right");
  //       } else {
  //         submenu.style.display = "block";
  //         arrow.classList.remove("right");
  //         arrow.classList.add("down");
  //       }
  //     }
  //   });
  // });

  let allowNavigation = false;

  submenuParents.forEach((parent) => {
    parent.addEventListener("click", (event) => {
      const submenu = parent.nextElementSibling;
      const arrow = parent.querySelector(".custom-arrow");

      if (!submenu) return;

      // OPEN submenu → prevent navigation
      if (submenu.style.display !== "block" && !allowNavigation) {
        event.preventDefault();

        submenu.style.display = "block";
        arrow.classList.remove("right");
        arrow.classList.add("down");

        // After 2000ms, allow navigation
        setTimeout(() => {
          allowNavigation = true;
        }, 2000);
      }
      // CLOSE submenu (or after delay) → navigation allowed
      else {
        submenu.style.display = "none";
        arrow.classList.remove("down");
        arrow.classList.add("right");
      }
    });
  });
  
  const mobileSearchButton = document.getElementById(
    "mobile-nav-search-button"
  );
  const mobileSearchContainer = document.querySelector(
    ".search-container-for-mobile"
  );
  const closeBtn = document.querySelector(".close-btn");
  if (mobileSearchButton && mobileSearchContainer) {
    mobileSearchButton.addEventListener("click", function (e) {
        // console.log(mobileSearchButton, 'mobileSearchButton');
        
      e.preventDefault();
      mobileSearchContainer.classList.add("active");
      document.body.classList.add("no-scroll");
      document.body.style.overflow = "hidden";
    });
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        mobileSearchContainer.classList.remove("active");
        document.body.classList.remove("no-scroll");
        document.body.style.overflow = "";
      });
    }
    mobileSearchContainer.addEventListener("click", function (e) {
      if (e.target === mobileSearchContainer) {
        mobileSearchContainer.classList.remove("active");
        document.body.classList.remove("no-scroll");
        document.body.style.overflow = "";
      }
    });
  }
});
